import { WarningAmberRounded } from "@mui/icons-material"

export const WarningAmberRoundedFitIcon = (props) => {
    return <WarningAmberRounded viewBox="2 4 19 17" {...props} />
}

WarningAmberRoundedFitIcon.propTypes = WarningAmberRounded.propTypes